var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isConfigLoaded)?_c('w-sys-page',{key:_vm.pageInstanceKey,ref:"wSysPage",attrs:{"mode":"runtime","project-config":_vm.projectConfig,"config":_vm.config,"page-list":_vm.pageList}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }